<full-calendar #calendar class="h-100" [events]="events" [resources]="professionals" [options]="calendarOptions">
    <ng-template #resourceLabelContent let-args>
        <div class="custom-resource-header">
            <div class="flex">
                <img class="avatar mr-3" [src]="args.resource.extendedProps.image"/>
                <div class="flex flex-column text-left ">
                    <div class="title">
                        {{ args.resource.title }}
                    </div>
                    <div class="sub-title">
                        {{args.resource.extendedProps.description}}
                    </div>
                </div>
            </div>
        </div>
    </ng-template>
    <ng-template #resourceLabelContent let-args>
        <div class="custom-resource-header">
            <div class="flex">
                <img class="avatar mr-3" [src]="args.resource.extendedProps.image"/>
                <div class="flex flex-column text-left ">
                    <div class="title">
                        {{ args.resource.title }}
                    </div>
                    <div class="sub-title">
                        {{args.resource.extendedProps.description}}
                    </div>
                </div>
            </div>
        </div>
    </ng-template>
    <ng-template #eventContent let-args>
        <div class="flex flex-column" *ngIf="args.event.display !== 'background'">
            <div class="flex justify-content-between">
                <span>{{ args.event.startStr | date:'HH:mm' }} - {{ args.event.endStr | date:'HH:mm' }}</span>
                <div class="flex">
                    <split-icon name="edit" size="16"></split-icon>
                </div>
            </div>
            <b>{{args.event.extendedProps.client}}</b>
            <span>{{args.event.title}}</span>
        </div>
    </ng-template>
</full-calendar>
